export default __webpack_public_path__ + "static/media/github.9c0b26d3.svg";